module.exports = __webpack_public_path__ + "static/scale-model-of-garland-in-garland-texas-e82720a85490d2d7c52c114276116910.png";